import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PackageDetailService {
  constructor(private http: HttpClient) {}

  getBySlug(slug: string): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/api/website/package/${slug}`
    );
  }

  // getBySlug(slug: string): Observable<any> {
  //   return this.http.get<any[]>(`/api/packages/bySlug/${slug}`);
  // }
}
